import { render, staticRenderFns } from "./currentCash.vue?vue&type=template&id=641c44d5&scoped=true"
import script from "./currentCash.vue?vue&type=script&lang=js"
export * from "./currentCash.vue?vue&type=script&lang=js"
import style0 from "./currentCash.vue?vue&type=style&index=0&id=641c44d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c44d5",
  null
  
)

export default component.exports